import { FC } from "react";
export interface IconDataTypes {
  className?: string;
}
const StarIcon: FC<IconDataTypes> = ({ className = "fill-yellow-300" }) => {
  return (
    <svg
      className={`size-4 ${className}`}
      fill="none"
      height="18"
      viewBox="0 0 18 18"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.1114 6.0319H1.69177C1.0767 6.0319 0.768676 6.78042 1.20359 7.2182L4.59645 10.6334C4.73099 10.7688 4.80277 10.9526 4.79848 11.1407C4.79665 11.2212 4.76914 11.2983 4.7372 11.3723L2.71573 16.0553C2.68379 16.1293 2.65632 16.2065 2.65374 16.287C2.63618 16.8351 3.25917 17.2054 3.73578 16.8755L8.60888 14.2941C8.84447 14.1311 9.15553 14.1311 9.39112 14.2941L14.2642 16.8755C14.7408 17.2054 15.3638 16.8351 15.3463 16.287C15.3437 16.2065 15.3162 16.1293 15.2843 16.0553L13.2628 11.3723C13.2309 11.2983 13.2034 11.2212 13.2015 11.1407C13.1972 10.9526 13.269 10.7688 13.4036 10.6334L16.7964 7.2182C17.2313 6.78042 16.9233 6.0319 16.3082 6.0319H11.8886C11.6039 6.0319 11.3484 5.85595 11.2452 5.58885L9.64344 1.44305C9.41521 0.852317 8.58479 0.852317 8.35656 1.44305L6.75484 5.58885C6.65164 5.85595 6.39612 6.0319 6.1114 6.0319Z"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default StarIcon;
